import * as ActionTypes from "./types";

export function editQuestionaire(payload) {
  return {
    type: ActionTypes.EDIT_QUESTIONAIRE,
    payload,
  };
}

export function openQuestionaire(payload) {
  return {
    type: ActionTypes.OPEN_QUESTIONAIRE,
    payload,
  };
}

export function fetchUserTypes() {
  return {
    type: ActionTypes.FETCH_USER_TYPES,
  };
}

export function fetchUserTypesSuccess(payload) {
  return {
    type: ActionTypes.FETCH_USER_TYPES_SUCCESS,
    payload,
  };
}

export function fetchUserTypesFailed(payload) {
  return {
    type: ActionTypes.FETCH_USER_TYPES_FAILED,
    payload,
  };
}

export function setSelectedUserType(payload) {
  return {
    type: ActionTypes.SET_SELECTED_USER_TYPE,
    payload,
  };
}

export function createUserQuestionnaire(payload) {
  return {
    type: ActionTypes.CREATE_USER_QUESTIONNAIRE,
    payload,
  };
}

export function createUserQuestionnaireSuccess(payload) {
  return {
    type: ActionTypes.CREATE_USER_QUESTIONNAIRE_SUCCESS,
    payload,
  };
}

export function createUserQuestionnaireFailed(payload) {
  return {
    type: ActionTypes.CREATE_USER_QUESTIONNAIRE_FAILED,
    payload,
  };
}

export function updateUserQuestionnaire(payload) {
  return {
    type: ActionTypes.UPDATE_USER_QUESTIONNAIRE,
    payload,
  };
}

export function updateUserQuestionnaireSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_USER_QUESTIONNAIRE_SUCCESS,
    payload,
  };
}

export function updateUserQuestionnaireFailed(payload) {
  return {
    type: ActionTypes.UPDATE_USER_QUESTIONNAIRE_FAILED,
    payload,
  };
}
